import script from "./CustomPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomPagination.vue?vue&type=script&setup=true&lang=js"

import "./CustomPagination.vue?vue&type=style&index=0&id=581e94b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581e94b6"]])

export default __exports__